// Copyright (c) 2016 Deere & Company

import Settings from '../../user/shared/components/user-settings';

export default {
    component: Settings,
    name: 'SETTINGS',
    path: 'settings'
};



// WEBPACK FOOTER //
// ./src/routes/settings/settings.js